import { useIdentityStore } from '../lib/store';

export function useFeatureFlag(flags: string): boolean;
export function useFeatureFlag(flags: string[]): boolean[];
export function useFeatureFlag(flags: string | string[]): boolean | boolean[];
export function useFeatureFlag(flags: string | string[]) {
	const features = useIdentityStore((state) => state.features);

	const getValue = (flag: string) => features?.[flag]?.enabled ?? false;

	if (Array.isArray(flags)) {
		return flags.map(getValue);
	}

	return getValue(flags);
}
